const BOTTOM_NAVBAR_MARGIN_TOP_IN_VH = 1;
const NAVBAR_HEIGHT_IN_VH = 10;
const BOTTOM_MARGIN_TO_MAKE_ROOM_FOR_BOTTOM_NAVBAR_IN_VH =
  NAVBAR_HEIGHT_IN_VH + BOTTOM_NAVBAR_MARGIN_TOP_IN_VH;
const BOTTOM_MARGIN_TO_MAKE_ROOM_FOR_BOTTOM_NAVBAR =
  `${BOTTOM_MARGIN_TO_MAKE_ROOM_FOR_BOTTOM_NAVBAR_IN_VH}vh` as const;

export const MOBILE_NAVBAR_CONSTANTS = {
  BOTTOM_MARGIN_TO_MAKE_ROOM_FOR_BOTTOM_NAVBAR,
  NAVBAR_HEIGHT_IN_VH,
};
